






































import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { ActionInterface, BlockWithLinkInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BlockWithLinkEl',

  data: () => ({
    showPopup: false
  }),

  components: { ConfirmDialog },

  computed: {
    hasPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog')
    }
  },

  props: {
    templateItemData: {
      type: Object as () => BlockWithLinkInterface,
      required: true
    }
  }
})
